import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { Box } from '../Box/Box';
import { getAlignItems } from '../Cluster/Cluster';
import styles from './Columns.module.less';
export var ColumnsContext = /*#__PURE__*/React.createContext({
  collapse: false
});
/**
 * The `<Columns>` and `<Column>` components can be used to implement page-level designs
 * that align to Currency's responsive grid.
 */

export var Columns = function Columns(_ref) {
  var alignY = _ref.alignY,
      children = _ref.children,
      _ref$collapse = _ref.collapse,
      collapse = _ref$collapse === void 0 ? false : _ref$collapse,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? {
    mobile: 3,
    desktop: '3-half'
  } : _ref$spacing;
  return /*#__PURE__*/React.createElement(Box, {
    alignItems: getAlignItems(alignY),
    className: [styles.columns, _defineProperty({}, styles.collapse, collapse)],
    "data-currency": "Columns",
    display: "grid",
    gridGap: spacing
  }, /*#__PURE__*/React.createElement(ColumnsContext.Provider, {
    value: {
      collapse: collapse
    }
  }, children));
};